// Send customer support request to LD team
export const SEND_CUSTOMER_SUPPORT_MESSAGE_REQUEST = 'send_custom_support_message_request';
export const SEND_CUSTOMER_SUPPORT_MESSAGE_SUCCESS = 'send_custom_support_message_success';
export const SEND_CUSTOMER_SUPPORT_MESSAGE_FAILURE = 'send_custom_support_message_failure';
export const SEND_CUSTOMER_SUPPORT_MESSAGE_RESET = 'send_custom_support_message_reset';